import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { calculateServerDate } from '../helpers';
import { ITimeProvider } from '../models';

@Injectable({ providedIn: 'root' })
export class MobileTimeService implements ITimeProvider {
  private originalServerDate: Date;
  private originalLocalDate: Date;

  private getting$: Subject<Date>;
  private http = inject(HttpClient);

  get(): Observable<Date> {
    if (!this.originalServerDate && !this.getting$) {
      return this.getServerDate();
    }

    if (this.getting$) {
      return this.getting$.asObservable();
    }

    return of(
      calculateServerDate(this.originalServerDate, this.originalLocalDate),
    );
  }

  private getServerDate(): Observable<Date> {
    this.getting$ = new Subject<Date>();

    const fallbackNowIso = () => new Date().toISOString();

    const req$ = this.http.get<{ now: string }>(
      `${environment.apiUrl}public/time`,
    );

    return req$.pipe(
      catchError(() => of({ now: fallbackNowIso() })),
      map(({ now }) => this.finalizeNow(now)),
      finalize(() => this.cleanupGetting()),
    );
  }

  finalizeNow(now: string): Date {
    const date = new Date(now);

    this.originalServerDate = date;
    this.originalLocalDate = new Date();

    this.getting$?.next(date);
    return date;
  }

  private cleanupGetting(): void {
    if (this.getting$ && !this.getting$.closed) {
      this.getting$?.complete();
    }
    this.getting$ = null;
  }
}
